import React from "react";
import { cn } from "@/lib/utils";
import AccordionItem, {
  AccordionItemProps,
} from "@/components/ui/accordion/accordion-item";

export interface AccordionProps {
  className?: string;
  items?: AccordionItemProps[];
}

const Accordion: React.FC<AccordionProps> = ({ className, items }) => {
  return (
    <div
      role="tablist"
      className={cn("flex min-w-[287px] flex-col gap-2", className)}
    >
      {items?.map((item, index) => {
        return (
          <AccordionItem
            key={`${item.header}-${index}`}
            id={`${index}`}
            {...item}
          />
        );
      })}
    </div>
  );
};

export default Accordion;
